export default {
  'channelPartner.title': 'Partners',
  'channelPartner.description': 'Register partner entities and assign commercial ownership.',

  'channelPartner.fields.distributorId': 'Distributor',
};
